/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleCalendarTriggerDto } from './equipment-schedule-calendar-trigger-dto';


export interface UpdateEquipmentCalendarScheduleRequestDto { 
    name?: string | null;
    triggers?: Array<EquipmentScheduleCalendarTriggerDto> | null;
    replaceEquipmentIds?: Array<string> | null;
    unassignEquipmentIds?: Array<string> | null;
}

